import { createFileRoute } from '@tanstack/react-router';

import { ErrorBoundary } from '@/components/ErrorBoundary';
import { loaderUnitSettingsPage } from '@/loaders/unit.settings.loader';
import { UnitSettingsPage } from '@/routes/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/settings';

export const Route = createFileRoute('/_authenticated/_account/units/$endCustomerUnitId/settings/')({
  component: UnitSettingsPage,
  errorComponent: ErrorBoundary,
  loader: loaderUnitSettingsPage,
});
